import React from "react";
import LogoBootverzekering from "../assets/LogoBootverzekering.svg";

const Footer = () => {
  return (
    <footer>
      <div className="mx-auto w-full max-w-screen-xl p-4 py-6 lg:py-8">
        {/* De hoofdslogan */}
        <p className="text-center text-lg font-bold text-[#1a2a6c] mb-6">
          <a href="/" className="text-[#ff6f61] underline">
            Boot-verzekering.be
          </a>{" "}
          is de plaats om jouw vaartuig te verzekeren.
        </p>

        {/* Horizontale lijn */}
        <hr className="my-6 border-[#ff6f61] border-2 sm:mx-auto lg:my-8" />

        <div className="md:flex md:justify-between items-center">
          {/* Linkse kolom met logo en tekst */}
          <div className="mb-6 md:mb-0 flex items-center gap-x-4">
            <a href="/" className="flex items-center">
              <img
                src={LogoBootverzekering}
                className="h-20 sm:h-32 lg:h-40 w-auto"
                alt="Boot-verzekering Logo"
              />
              <h1 className="text-xl sm:text-2xl lg:text-3xl font-bold text-[#1a2a6c]">
                boot-verzekering.be
              </h1>
            </a>
          </div>

          {/* Rechtse kolom met informatie */}
          <div className="w-full text-left lg:text-right grid grid-cols-1 gap-6 lg:grid-cols-1">
            <ul className="text-[#1a2a6c] font-medium">
              <li className="mb-4">
                <a href="/informatie" className="hover:underline font-semibold">
                  Meer info
                </a>
                <p className="text-sm font-normal">
                  Info over de mogelijke waarborgen
                </p>
              </li>
              <li className="mb-4">
                <a href="/contact" className="hover:underline font-semibold">
                  Contact
                </a>
                <p className="text-sm font-normal">Neem contact met ons op</p>
              </li>
              <li className="mb-4">
                <a
                  href="/verzekeringsmodule"
                  className="hover:underline font-semibold"
                >
                  Offerte aanvragen
                </a>
                <p className="text-sm font-normal">
                  Vraag snel en simpel uw offerte aan
                </p>
              </li>
              <li>
                <a
                  href="https://www.deins.be/"
                  target="_blank"
                  className="hover:underline font-semibold"
                >
                  Toch op zoek naar andere verzekeringen?
                </a>
                <p className="text-sm font-normal">
                  Surf naar{" "}
                  <a
                    href="https://www.deins.be/"
                    target="_blank"
                    className="hover:underline font-semibold"
                  >
                    Deins.be
                  </a>
                </p>
              </li>
            </ul>
          </div>
        </div>

        {/* Ondernemingsnummer en FSMA-nummer */}
        <div className="mt-6 text-center">
          <p className="text-sm text-[#1a2a6c]">
            Ondernemingsnummer: BE0752669718 - FSMA nummer: 0752669718
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
